import { LootBoxRarityEnum } from '../../types/loot-box/loot-box.enums'
import { authFetch } from '../../common/networking/auth-fetch';

const base = `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/loot-tables`

export type LootBoxDetailCardLineItemDto = {
  body: string
  align: 'center' | 'left' | 'right'
}

export type LootBoxDetailCardDto = {
  title: string
  lineItems: LootBoxDetailCardLineItemDto[]
  bgColorHex?: string
}

export type LootBoxDropTableItemDto = {
  id: string
  name: string
  rarity: LootBoxRarityEnum
  probability: number // Range [0, 1]
  detailCard?: LootBoxDetailCardDto
}

/* GET /loot-tables/rarity?rarity=X&strict=Y */
export async function getLootTableByRarity(
  params: { rarity: LootBoxRarityEnum, strict: boolean },
): Promise<LootBoxDropTableItemDto[]> {
  const qs = new URLSearchParams({
    rarity: params.rarity,
    strict: String(params.strict ?? true),
  })
  
  const url = `${base}/rarity?${qs}`
  const res = await authFetch().get(url)
  return res.json()
}
